<div class="form-group">
  <!-- search -->
  <div #searchContainer [ngClass]="{'active' : showMyContainer, 'disabled' : disabled}"
    class="div select-bg search-container" [style.background-color]="bgColor || 'var(--white)'">
    <div class="search-input-wrapper">
      <input type="text" readonly class="search" style="height: 34px; display: block; width: 100%; padding-left: 12px;"
        (click)="openDropdown()" name="selectedOption" [(ngModel)]="selectedOption" [placeholder]="(placeholder | translate) || ''">
      <div class="dropdown-arrow" (click)="openDropdown()"></div>
    </div>
    <div *ngIf="showClearFIlter" class="clear-filter" (click)="selectOption(undefined)">X</div>
    <div class="show-list" *ngIf="showMyContainer" [style.background-color]="bgColor || 'var(--white)'">
      <div class="backdrop" (click)="openDropdown()"></div>
      <div style="z-index: 100; overflow: hidden auto;">
        <div class="divider"></div>
        <input type="text" class="search-marke" (input)="filterOptions()" [attr.placeholder]="'global.search' | translate"
          name="searchTerm" name="searchTerm" [(ngModel)]="searchTerm">
        <ul style="margin-bottom: 12px;">
          <li *ngFor="let option of filteredOptions" [ngClass]="{'active': selectedOption === option.name}"
            (click)="selectOption(option)">
            {{ option.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>